import React from "react";
import { UseFormSetValue, FieldErrors } from "react-hook-form";
import { CheckCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { type UpdateCampaignRouletteFormData } from "../../validations/campaign-roulette.validation";

interface RegulationsCardProps {
  setValue: UseFormSetValue<UpdateCampaignRouletteFormData>;
  errors: FieldErrors<UpdateCampaignRouletteFormData>;
  hasRegulationFile: boolean;
  regulationsUrl?: string;
}

export const RegulationsCard: React.FC<RegulationsCardProps> = ({
  setValue,
  errors,
  hasRegulationFile,
  regulationsUrl,
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setValue("regulations", file);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Regulamento</CardTitle>
      </CardHeader>
      <CardContent>
        {hasRegulationFile ? (
          <div className="space-y-3">
            <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
              <CheckCircle className="h-5 w-5 text-green-600" />
              <div>
                <p className="text-sm font-medium text-green-800">
                  Arquivo de regulamento já enviado
                </p>
                <p className="text-xs text-green-600">
                  Esta campanha já possui um arquivo de regulamento anexado.
                </p>
              </div>
            </div>
            {regulationsUrl && (
              <p className="text-sm text-blue-600">
                <a
                  href={regulationsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-blue-800"
                >
                  Visualizar regulamento atual
                </a>
              </p>
            )}
          </div>
        ) : (
          <div>
            <Label htmlFor="regulations">Arquivo do Regulamento</Label>
            <Input
              id="regulations"
              type="file"
              accept=".pdf"
              onChange={handleFileChange}
            />
            <p className="text-xs text-gray-500 mt-1">
              Envie um arquivo PDF com o regulamento da campanha
            </p>
            {errors.regulations && (
              <p className="text-sm text-red-500 mt-1">
                {errors.regulations.message}
              </p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
